import { combineReducers } from 'redux';

import {
  LIBRARY_MODIFIER_HUB_SET_MODIFIERS,
  LIBRARY_MODIFIER_HUB_SET_META_MODIFIERS,
  LIBRARY_MODIFIER_HUB_SET_MODIFIER_DETAIL,
  LIBRARY_MODIFIER_HUB_OPEN_RIGHT_COLUMN,
  LIBRARY_MODIFIER_HUB_CLOSE_RIGHT_COLUMN,
  LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_ITEMS,
  LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_META,
  LIBRARY_MODIFIER_HUB_SHOW_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_HUB_HIDE_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_HUB_SET_MODIFIER_ALL_ITEMS,
  LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN,
  LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE,
  LIBRARY_MODIFIER_HUB_SHOW_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_HUB_HIDE_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_HUB_SET_PREVIOUS_MODIFIER_FORM,
  LIBRARY_MODIFIER_HUB_IS_SUBMITTING_FORM,
  LIBRARY_MODIFIER_HUB_SET_DELETED_MODIFIER,
  LIBRARY_MODIFIER_HUB_SHOW_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_HUB_HIDE_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_HUB_SET_CHANNEL_ASYNC_JOB,
} from 'actions/businessLibrary/modifier/constants';

import createReducer from 'utils/createReducer';

const modifiers = createReducer([], {
  [LIBRARY_MODIFIER_HUB_SET_MODIFIERS]: (_, { payload }) => payload.modifiers,
});

const modifierMeta = createReducer(
  {},
  {
    [LIBRARY_MODIFIER_HUB_SET_META_MODIFIERS]: (_, { payload }) => payload.meta,
  }
);

const modifierDetail = createReducer(null, {
  [LIBRARY_MODIFIER_HUB_SET_MODIFIER_DETAIL]: (draft, { payload }) =>
    payload.modifier,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_MODIFIER_HUB_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_MODIFIER_HUB_CLOSE_RIGHT_COLUMN]: () => false,
});

const applySetItems = createReducer(
  {
    items: [],
    meta: {},
  },
  {
    [LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_ITEMS]: (draft, { payload }) => {
      draft.items = payload.items;
    },
    [LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_META]: (draft, { payload }) => {
      draft.meta = payload.meta;
    },
  }
);

const showApplySetItemModal = createReducer(false, {
  [LIBRARY_MODIFIER_HUB_SHOW_APPLY_SET_ITEM_MODAL]: () => true,
  [LIBRARY_MODIFIER_HUB_HIDE_APPLY_SET_ITEM_MODAL]: () => false,
});

const modifierIdSetAllItem = createReducer(null, {
  [LIBRARY_MODIFIER_HUB_SET_MODIFIER_ALL_ITEMS]: (_, { payload }) =>
    payload.modifierId,
});

const showSetAllItemConfirmationModal = createReducer(false, {
  [LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN]: () => true,
  [LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE]: () => false,
});

const showModifierOptionsModal = createReducer(false, {
  [LIBRARY_MODIFIER_HUB_SHOW_MODIFIER_OPTIONS_MODAL]: () => true,
  [LIBRARY_MODIFIER_HUB_HIDE_MODIFIER_OPTIONS_MODAL]: () => false,
});

const previousModifierForm = createReducer(
  {
    name: null,
    options: [],
  },
  {
    [LIBRARY_MODIFIER_HUB_SET_PREVIOUS_MODIFIER_FORM]: (
      draft,
      { payload }
    ) => ({
      ...payload.previousModifierForm,
    }),
  }
);

const isSubmittingForm = createReducer(false, {
  [LIBRARY_MODIFIER_HUB_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const deletedModifier = createReducer(null, {
  [LIBRARY_MODIFIER_HUB_SET_DELETED_MODIFIER]: (draft, { payload }) =>
    payload.deletedModifier,
});

const showDeleteModifierModal = createReducer(false, {
  [LIBRARY_MODIFIER_HUB_SHOW_DELETE_MODIFIER_MODAL]: () => true,
  [LIBRARY_MODIFIER_HUB_HIDE_DELETE_MODIFIER_MODAL]: () => false,
});

const eventAsyncJob = createReducer(
  {
    channelName: null,
  },
  {
    [LIBRARY_MODIFIER_HUB_SET_CHANNEL_ASYNC_JOB]: (_, { payload }) => ({
      ...payload,
    }),
  }
);

export default combineReducers({
  applySetItems,
  deletedModifier,
  eventAsyncJob,
  isSubmittingForm,
  modifiers,
  modifierDetail,
  modifierIdSetAllItem,
  modifierMeta,
  openRightColumn,
  previousModifierForm,
  showApplySetItemModal,
  showDeleteModifierModal,
  showSetAllItemConfirmationModal,
  showModifierOptionsModal,
});
